
export { default as ModalAriaLabelledByHeading } from "./components/Modal/ModalAriaLabelledByHeading"